/**
 * Link
 *
 * @author Dominique Rau [domi.github@gmail.com](mailto:domi.github@gmail.com)<br/>
 * @version 0.0.1
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Link as MaterialLink, Button, IconButton } from '@material-ui/core';
import * as React from 'react';
import { Link as RouterLinkFix } from 'react-router-dom';
var InnerRouterLinkFix = RouterLinkFix;
// eslint-disable-next-line react/display-name
export var RouterLink = React.forwardRef(function (props, ref) { return (React.createElement(InnerRouterLinkFix, __assign({ innerRef: ref }, props))); });
var LinkFix = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(MaterialLink, __assign({ component: RouterLink }, props)));
};
export var Link = LinkFix;
var ButtonFix = Button;
var IconButtonFix = IconButton;
export var ButtonLink = function (_a) {
    var to = _a.to, props = __rest(_a, ["to"]);
    return (React.createElement(ButtonFix, __assign({ component: RouterLink, to: to }, props)));
};
export var IconButtonLink = function (_a) {
    var to = _a.to, props = __rest(_a, ["to"]);
    return (React.createElement(IconButtonFix, __assign({ component: RouterLink, to: to }, props)));
};
export default Link;
